import { render, staticRenderFns } from "./GradeChart.vue?vue&type=template&id=fce77572&scoped=true&"
import script from "./GradeChart.vue?vue&type=script&lang=js&"
export * from "./GradeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce77572",
  null
  
)

export default component.exports